const stopSound = (playId) => {
  window.HiyaJSBridge.callHandler("stopSound", { playId });
};
export {
  stopSound
};
